import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Table from '../../components/MUITable'

const SalesChannelsToolbar = (props) => {
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Eventos de venta
      </Typography>
    </Toolbar>
  )
}


const SaleEvents = () => {
  const app = React.useContext(AppContext)  
  const { vendor } = app
  const SalesChannels = React.useContext(SalesChannelsContext)
  const { events, loading } = SalesChannels.events
  
  const [selected, setselected] = React.useState([])
  
  return (
    <Stack>
      {loading || !events && <CircularProgress size={27}/>}
      <Box sx={{ width: '90vw', }}>
        <SalesChannelsToolbar vendor={vendor}/>
        {!loading && events && 
          <Paper sx={{ padding: "30px",  height:'80vh', display: 'flex', flexDirection: 'column' }}>
            <Table
              setmodel={setselected}
              data={events}
              columns={[
                {headerName:"Canal", field:"vendor"},
                {headerName:"Venta", field:"sale"},
                {headerName:"Estado", field:"status"},
                {headerName:"Elemento", field:"sku"},
                {headerName:"Cobrado", field:"pretotal", valueGetter:({row}) => row.pretotal/100 },
                {headerName:"Comision", field:"comision", valueGetter:({row}) => row.comision/100 },
                {headerName:"Total", field:"total", valueGetter:({row}) => row.total/100 },
              ]}
              options={{
                selection: true,
                pageSizes:[5, 10,25,50,100,250]
              }}
            />
          </Paper>
        }
      </Box>
    </Stack>
  )
}
export default SaleEvents